import { RentManagerProperty } from "../../data/models.interface"
import useQuery from "../useQuery"

export const useGetRentManagerPropertiesQuery = () => {
	const url = `${process.env.REACT_APP_ACCESS_CONTROL_BACK_URL}/rent-manager-properties`
	return useQuery<void, RentManagerPropertiesOutput>(url)
}
interface RentManagerPropertiesOutput {
	rentManagerProperties: RentManagerProperty[]
}
